// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"c16379ad","571":"0a953264","717":"6386a134","787":"2fc93668","950":"c657be11"}[chunkId] + ".chunk.js";
};